var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71643 5.49853L10.7482 1.46788C11.0839 1.13219 11.0839 0.587462 10.7482 0.251769C10.4124 -0.0839231 9.86751 -0.0839231 9.53173 0.251769L5.5 4.28242L1.46827 0.251769C1.13249 -0.0839231 0.587619 -0.0839231 0.251837 0.251769C-0.0839456 0.587462 -0.0839456 1.13219 0.251837 1.46788L4.28357 5.49853L0.251837 9.52918C-0.0839456 9.86487 -0.0839456 10.4096 0.251837 10.7453C0.413843 10.9073 0.634238 11 0.854169 11C1.0741 11 1.2945 10.919 1.4565 10.7453L5.49993 6.71464L9.53166 10.7453C9.69367 10.9073 9.91406 11 10.134 11C10.3539 11 10.5743 10.919 10.7363 10.7453C11.0721 10.4096 11.0721 9.86487 10.7363 9.52918L6.71643 5.49853Z",
    fill: "#FF585D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCross);
export default __webpack_public_path__ + "static/media/ic-cross.24f92f8f994fde3ce5ef26337851ae34.svg";
export { ForwardRef as ReactComponent };